<template>
    <div class="user-profile">
        <grid-single-column>
            <search-content></search-content>
        </grid-single-column>
    </div>
</template>
<script>
import searchContent from "@/components/search/search-content.vue"
export default {
    name: 'Profile',
    components: {
        'search-content': searchContent
    }
}
</script>